module.exports = __webpack_public_path__ + "img/user-plus.5047d004.svg";